import React from 'react';
import { Facebook, Twitter, Linkedin, Instagram, Mail, Phone, MapPin } from 'lucide-react';
import { footerLinks } from '../mockData';

const Footer = () => {
  return (
    <footer className="bg-[#0A1F3B] text-white">
      <div className="max-w-[1400px] mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-[#00ACC1] flex items-center justify-center rounded">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
                </svg>
              </div>
              <span className="text-xl font-bold">SUPREME<br/>GLOBAL<br/>FREIGHT</span>
            </div>
            <p className="text-white/70 text-sm mb-6">
              Your trusted partner in global logistics and freight solutions.
            </p>
            <div className="flex gap-4">
              <a href="#" className="text-white/70 hover:text-[#00ACC1] transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-white/70 hover:text-[#00ACC1] transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="#" className="text-white/70 hover:text-[#00ACC1] transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="text-white/70 hover:text-[#00ACC1] transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Products & Services</h3>
            <ul className="space-y-3">
              {footerLinks.products.map((link, index) => (
                <li key={index}>
                  <a href="#" className="text-white/70 hover:text-[#00ACC1] transition-colors text-sm">
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Support</h3>
            <ul className="space-y-3">
              {footerLinks.support.map((link, index) => (
                <li key={index}>
                  <a href="#" className="text-white/70 hover:text-[#00ACC1] transition-colors text-sm">
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Company</h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  <a href="#" className="text-white/70 hover:text-[#00ACC1] transition-colors text-sm">
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#00ACC1] flex-shrink-0 mt-0.5" />
                <a href="mailto:info@supremeglobalfreight.com" className="text-white/70 hover:text-[#00ACC1] transition-colors text-sm">
                  info@supremeglobalfreight.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-[#00ACC1] flex-shrink-0 mt-0.5" />
                <a href="tel:+14044369860" className="text-white/70 hover:text-[#00ACC1] transition-colors text-sm">
                  (404) 436-9860
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#00ACC1] flex-shrink-0 mt-0.5" />
                <span className="text-white/70 text-sm">
                  1870 The Exchange SE<br/>
                  Ste 220 #652891<br/>
                  Atlanta, GA, 30339, USA
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm">
              © {new Date().getFullYear()} Supreme Global Freight. All rights reserved.
            </p>
            <div className="flex flex-wrap gap-6">
              {footerLinks.legal.map((link, index) => (
                <a 
                  key={index} 
                  href="#" 
                  className="text-white/60 hover:text-[#00ACC1] transition-colors text-sm"
                >
                  {link}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;